const alert = {
    types: {
        success: {
            color: 'GREEN_600',
            borderColor: 'GREEN_400',
            backgroundColor: 'GREEN_300',
        },
        destructive: {
            color: 'RED_600',
            borderColor: 'RED_500',
            backgroundColor: 'RED_300',
        },
        warning: {
            color: 'YELLOW_800',
            borderColor: 'YELLOW_400',
            backgroundColor: 'YELLOW_300',
        },
        information: {
            color: 'BLUE_700',
            borderColor: 'BLUE_600',
            backgroundColor: 'BLUE_200',
        },
    },
};
export default alert;
//# sourceMappingURL=alert.js.map